import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../../components/Button';
import TextField from '../../../../../components/TextField';
import validate from './validation';

const propTypes = {
  onFilter: PropTypes.func.isRequired,
};

function FilterBar(props) {
  const { onFilter } = props;
  const filterParams = {
    name: null,
  };
  const [filter, setFilter] = React.useState(filterParams);
  const [errors, setErrors] = React.useState({});

  function changeFilter(event) {
    const { target } = event;
    const { name, value } = target;
    setFilter({ ...filter, [name]: value.replace(/[`~!@#$%^&*()_|+\=?;:'",<>\{\}\[\]\\\/]/gi, '') });
  }

  async function handleFilter() {
    setErrors({});
    const result = await validate(filter);
    if (!result.isValid) {
      setErrors(result.errors);
      return;
    }
    onFilter({
      ...filter,
      available_from: filter.available_from ? filter.available_from.toISOString() : null,
      available_to: filter.available_to ? filter.available_to.toISOString() : null,
    });
  }

  function handleReset() {
    setErrors({});
    setFilter(filterParams);
    onFilter({});
  }

  return (
    <Grid container item xs="auto" spacing={1}>
      <Grid item xs={12} sm>
        <TextField
          type="text"
          label="Nombre"
          name="text"
          value={filter.text || ''}
          onChange={changeFilter}
          margin="dense"
          error={!!errors.name}
          helperText={errors.name}
        />
      </Grid>
      <Grid item xs={6} sm="auto">
        <Button color="primary" fullWidth square onClick={handleFilter}>Filtrar</Button>
      </Grid>
      <Grid item xs={6} sm="auto">
        <Button color="secondary" fullWidth onClick={handleReset} square>Reiniciar</Button>
      </Grid>
    </Grid>
  );
}

FilterBar.propTypes = propTypes;

export default FilterBar;
